/** Panitia (buyer) = Indonesian; Supplier = English. */

export const isBuyerLocale = mode => mode !== 'supplier';

export const copy = {
  dealTitle: {
    id: 'Kesepakatan harga selesai',
    en: 'Price agreement complete',
  },
  dealSub: {
    id: 'Harga dengan mitra ini telah disepakati. Pemenang cargo dipilih di Awarding.',
    en: 'The price with Pertamina has been agreed. Please return to the cargo list to continue with other cargoes.',
  },
  historyDoneAlert: (price, locale) =>
    locale === 'id'
      ? `Negosiasi dengan mitra ini selesai: harga disepakati pada ${price}.`
      : `Negotiation complete: price agreed at ${price}.`,

  // System message titles by BE NegotiationMessageKind (be#451 C5); the
  // body is the server-written message text.
  systemTitle: {
    1: { id: 'Negosiasi dimulai', en: 'Negotiation started' },
    2: { id: 'Usulan harga baru', en: 'New price proposal' },
    3: { id: 'Kesepakatan tercapai', en: 'Agreement reached' },
    4: { id: 'Partner keluar', en: 'Withdrawn' },
    5: { id: 'Batas waktu terlewati', en: 'Deadline passed' },
    6: { id: 'Batas waktu diperpanjang', en: 'Deadline extended' },
  },

  confirmSubmit: (price, against, locale, role = 'buyer') =>
    locale === 'id'
      ? {
          title: 'Kirim usulan harga?',
          message: `Usulan harga akan dikirim kepada mitra (harga terakhir mitra ${against}) dan langsung terlihat oleh mereka. Mohon periksa kembali angkanya.`,
          subject: price,
          confirm: 'Kirim usulan',
          cancel: 'Periksa lagi',
        }
      : {
          title:
            role === 'seller'
              ? 'Send your price proposal?'
              : 'Send price proposal?',
          message: `Your proposal will be sent to Pertamina (latest Pertamina target ${against}) and they will see it immediately. Please double-check the figure.`,
          subject: price,
          confirm: 'Send proposal',
          cancel: 'Review again',
        },

  confirmAccept: (price, locale, role = 'buyer') =>
    locale === 'id'
      ? {
          title: 'Setujui harga ini?',
          message:
            'Keputusan ini final: baris alpha ini ditutup pada harga tersebut dan tidak dapat diubah. Baris lain dan mitra lain pada cargo ini tetap berjalan.',
          subject: price,
          confirm: 'Setujui harga',
          cancel: 'Kembali',
        }
      : {
          title:
            role === 'seller'
              ? 'Accept Pertamina’s proposal?'
              : 'Accept this offer?',
          message:
            'This decision is final: this alpha line closes at this price and it cannot be changed. Your other lines stay open until the deadline.',
          subject: price,
          confirm: 'Agree on price',
          cancel: 'Go back',
        },

  confirmWithdraw: (subject, locale) =>
    locale === 'id'
      ? {
          title: 'Keluarkan mitra dari negosiasi?',
          message:
            'Mitra ini keluar dari negosiasi cargo: semua baris alpha yang masih aktif ditutup dan tidak dapat menerima usulan lagi. Tindakan ini tidak dapat dibatalkan.',
          subject,
          confirm: 'Keluarkan mitra',
          cancel: 'Batal',
          reasonLabel: 'Alasan (opsional)',
          reasonPlaceholder: 'Tulis alasan singkat…',
        }
      : {
          title: 'Withdraw from this negotiation?',
          message:
            'You leave the negotiation for this cargo: every alpha line that is still active is closed and you cannot send proposals anymore. This cannot be undone.',
          subject,
          confirm: 'Withdraw',
          cancel: 'Cancel',
          reasonLabel: 'Reason (optional)',
          reasonPlaceholder: 'Write a short reason…',
        },

  // New in be#455: English for both portals.
  confirmWithdrawRound: (subject, roundNo) => ({
    title: `Withdraw round ${roundNo}?`,
    message:
      'Your last proposal on this line is withdrawn. It stays in the history as withdrawn and it is your turn again.',
    subject,
    confirm: 'Withdraw round',
    cancel: 'Keep it',
  }),
};

export const t = (entry, mode) => {
  const locale = isBuyerLocale(mode) ? 'id' : 'en';
  if (typeof entry === 'function') return entry(locale);
  return entry?.[locale] ?? entry?.en ?? '';
};
